import _ from "underscore";

export default function calculateReferenceAtLevel(reference, level) {
  return _.first(reference.split("."), level).join(".");
}
